var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97381 0.961428H2.56351C2.13848 0.961428 1.73086 1.1303 1.43032 1.4309C1.12978 1.73149 0.960938 2.13918 0.960938 2.56429V15.3872C0.960938 15.8123 1.12978 16.22 1.43032 16.5206C1.73086 16.8212 2.13848 16.9901 2.56351 16.9901H12.179C12.604 16.9901 13.0116 16.8212 13.3121 16.5206C13.6127 16.22 13.7815 15.8123 13.7815 15.3872V5.77002M8.97381 0.961428C9.22746 0.961017 9.47868 1.0108 9.71302 1.1079C9.94735 1.20501 10.1602 1.34753 10.3392 1.52724L13.2142 4.40277C13.3944 4.5819 13.5373 4.79495 13.6346 5.02962C13.732 5.26429 13.7819 5.51594 13.7815 5.77002M8.97381 0.961428V4.96858C8.97381 5.18113 9.05823 5.38498 9.2085 5.53528C9.35877 5.68558 9.56258 5.77001 9.77509 5.77001L13.7815 5.77002M5.76866 6.57144H4.16609M10.5764 9.77717H4.16609M10.5764 12.9829H4.16609",
    stroke: "#2B3688",
    strokeWidth: 1.92328,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile1);
export default __webpack_public_path__ + "static/media/file1.c6b97f9faa080f0d502b03034e86534f.svg";
export { ForwardRef as ReactComponent };